import React, {Fragment} from "react";
import {Container, Grid, Header, List, Popup, Segment} from "semantic-ui-react";

import Address from "./Address";
import {Images} from "./Images";
import {FormattedMessage} from "react-intl";

import {
    FacebookIcon,
    FacebookShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton,
} from 'react-share';

import {Evaluate} from "./Evaluate";

const domain = window.location.origin;

export const Description = props => {

    const {id, from, name, score_avg, about, description, address, hours, contact, pathname, images} = props;

    const shareUrl = domain + '' + pathname;

    return (
        <Container as="section" className="section-description">
            <Grid stackable columns={"equal"}>
                <Grid.Column>
                    <Header as="h2" className="mb-0">
                        <FormattedMessage id="Descrição"/>
                    </Header>
                    <List className="actions-details" horizontal>
                        <List.Item
                            icon="star"
                            content={<FormattedMessage id="Escrever um comentário"/>}
                            href={'#comments'}
                        />
                        {/*<List.Item icon="heart" content={<FormattedMessage id="Salvar como favorito"/>}/>*/}

                        <Popup
                            trigger={<List.Item icon="share" content={<FormattedMessage id="Compartilhar"/>}/>}
                            hoverable
                        >
                            <Grid centered divided columns={3}>
                                <Grid.Column textAlign='center'>
                                    <FacebookShareButton
                                        url={shareUrl}
                                        quote={name}
                                    >
                                        <FacebookIcon
                                            size={24}
                                            round
                                        />
                                    </FacebookShareButton>
                                </Grid.Column>
                                <Grid.Column textAlign='center'>
                                    <TwitterShareButton
                                        url={shareUrl}
                                        title={name}
                                    >
                                        <TwitterIcon
                                            size={24}
                                            round
                                        />
                                    </TwitterShareButton>
                                </Grid.Column>
                                <Grid.Column textAlign='center'>
                                    <WhatsappShareButton
                                        url={shareUrl}
                                        title={name}
                                        separator=":: "
                                    >
                                        <WhatsappIcon
                                            size={24}
                                            round
                                        />
                                    </WhatsappShareButton>
                                </Grid.Column>
                            </Grid>


                        </Popup>
                    </List>
                    <Segment>
                        {description && <p>{description}</p>}
                        <div className={'placeDetailsContent'} dangerouslySetInnerHTML={{__html: about}}/>
                    </Segment>

                    {(images && images.length > 0) && <Images images={images}/>}

                    {
                        from === 'places' &&
                        <Fragment>
                            <Evaluate place_id={id} score_avg={score_avg} />
                        </Fragment>
                    }
                </Grid.Column>
                <Grid.Column>
                    <Address
                        name={props.name}
                        address={address}
                        hours={hours}
                        contact={contact}
                    />
                </Grid.Column>
            </Grid>
        </Container>
    );
};
